<template>
  <div>
    <v-card class="pl-5 pr-5">
      <h1>Assignment</h1>
      <v-divider></v-divider>
      <Notification :notify="notify" />
      <div class="row" v-show="!isEdit">
        <div class="pl-3 col">
          <v-text-field
            id="search"
            v-model="Search"
            label="Search"
            required
            append-outer-icon="mdi-table-search"
            @click:append-outer="onSearch"
            v-on:keyup.enter="onSearch()"
          ></v-text-field>
        </div>
        <div class="col">
          <div class="float-right">
            <v-btn color="primary" @click="onNew()" class="mt-4" id="btnNew">
              New Assignment 
            </v-btn>
          </div>
        </div>
      </div>
      <div v-show="isEdit">
        <v-form ref="form" v-model="valid" lazy-validation>
          <div class="row">
            <div class="col">
              <!-- <pre>{{groups}}</pre> -->
              <v-select
                id="Organization"
                v-model="selectedObj.organizationGroupId"
                :rules="groupRules"
                :items="groups"
                label="Groups"
                item-text="Name"
                item-value="id"
                required
              ></v-select>
            </div>
            <div class="col">
              <!-- <pre>{{collections}}</pre> -->
              <v-select
                id="organizationCollection"
                v-model="selectedObj.organizationCollectionId"
                :rules="collectionRules"
                :items="collections"
                label="Collections"
                item-text="Name"
                item-value="id"
              ></v-select>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="float-right action-area">
                <v-btn @click="onCancel()" id="btnCancel"> Cancel </v-btn>
                <v-btn
                  id="btnSave"
                  class="mr-4"
                  color="primary"
                  @click="onSave()"
                  :loading="loading"
                  :disabled="loading"
                >
                  Save
                </v-btn>
              </div>
            </div>
          </div>
        </v-form>
      </div>
      <div class="row" v-show="!isEdit">
        <div class="col">
          <ConfirmationDialog ref="confirm" />
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Collection</th>
                  <th class="text-left">Group</th>
                  <th style="width: 100px"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in list" :key="item.id">
                  <td>{{ item.organizationCollection.Name }}</td>
                  <td>{{ item.organizationGroup.Name }}</td>
                  <td>
                    <v-icon class="mr-2 icon-edit" @click="onEdit(item)"
                      >mdi-comment-edit</v-icon
                    >
                    <v-icon class="mr-2 icon-delete" @click="onDelete(item)"
                      >mdi-delete</v-icon
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
      <div class="row" v-show="!isEdit">
        <div class="col">
          <Pagination :paging="paging" v-on:next="onNextPage" />
        </div>
      </div>
      <v-overlay :value="overlay">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import Notification from "@/components/Notification";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import Pagination from "@/components/Pagination";
import * as api from "@/api";

export default {
  name: "OrgCollectionGroup",
  components: {
    Notification,
    ConfirmationDialog,
    Pagination,
  },
  created() {
    this.getCollectionGroupByPagin();
    this.getCollection();
    this.getUserGroups();
  },
  computed: {
    computedStartDateFormatted() {
      return this.formatDate(this.startDate);
    },
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    resultQuery() {
      if (this.Search) {
        return this.list.filter((item) => {
          return this.Search.toLowerCase()
            .split(" ")
            .every((v) => item.email.toLowerCase().includes(v));
        });
      } else {
        return this.list;
      }
    },
  },

  methods: {
    onSearch() {
      this.paging.page = 1;
      this.paging.keyword = this.Search;
      this.getCollectionGroupByPagin();
    },
    onNew() {
      this.isEdit = true;
      this.selectedObj.id = 0;
      this.groupId = "";
      this.collectionId = "";
    },
    onSave() {
      this.loading = true;
      new Promise((resolve, reject) => {
        api
          .update("organization-collection-group", this.selectedObj)
          .then((response) => {
            resolve(response);
            if (response.status === 200 || response.status === 201) {
              this.notify.type = 1;
              this.notify.message =
                this.selectedObj.id === -1
                  ? "Record successfully saved."
                  : "Record successfully updated.";
              this.loading = false;
              this.isEdit = false;
              this.getCollectionGroupByPagin();
              setTimeout(() => {
                this.notify.type = 0;
              }, 3000);
            } else {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data.");
              this.loading = false;
            }
          })
          .catch((error) => {
            this.notify.type = 4;
            console.log("error " + error);
            if (error == "Error: Request failed with status code 409")
              this.notify.errors.push(
                "Publication already assign to license for selected date."
              );
            else this.notify.errors.push("Failed to save data. " + error);

            this.loading = false;
            reject(error);
          });
      });
    },
    onEdit(obj) {
      this.isEdit = true;
      this.selectedObj.organizationCollectionId = obj.organizationCollection.id;
      this.selectedObj.organizationGroupId = obj.organizationGroup.id;
    },
    async onDelete(obj) {
      //this.isEdit = false;
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure, Do you really want to delete this record?"
        )
      ) {
        new Promise((resolve, reject) => {
          api
            .DeleteByID("organization-collection-group", obj.id)
            .then((response) => {
              resolve(response);
              if (response.status === 200 || response.status === 201) {
                this.notify.type = 1;
                this.notify.message = "Record successfully deleted";
                this.getCollectionGroupByPagin();
                setTimeout(() => {
                  this.notify.type = 0;
                }, 3000);
              } else {
                this.notify.type = 4;
                this.notify.errors.push("Failed to save data.");
              }
            })
            .catch((error) => {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data. " + error);
              reject(error);
            });
        });
      }
    },
    onCancel() {
      this.isEdit = false;
      this.notify.type = 0;
    },
    getCollection() {
      let that = this;
      new Promise((resolve, reject) => {
        api
          .getAll("organization-collection")
          .then((response) => {
            console.log(response.data);
            response.data.forEach(e => {
              that.collections.push(e);
            });
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getUserGroups() {
      this.groups = [];
      new Promise((resolve, reject) => {
        api
          .getAll("organization-group")
          .then((response) => {
            console.log(response);
            response.data.forEach(e=> {
              this.groups.push(e);
            })
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getCollectionGroupByPagin() {
      let that = this;
      that.overlay = true
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getByPagin("organization-collection-group", this.paging)
          .then(response => {
            console.log(response.data.data);
            if(response.data != null && response.data.data != null && response.data.data.length > 0) {
              response.data.data.forEach(e=> {
                this.list.push(e);
              })
            }
            resolve(response);
            this.paging.count = response.data.count;
            that.overlay = false
          })
          .catch(error => {
            reject(error);
            that.overlay = false
          });
      });
    },
    onNextPage(page) {
      this.paging.page = page;
      this.paging.keyword = this.Search;
      this.getCollectionGroupByPagin();
    }
  },
  data() {
    return {
      valid: true,
      list: [],
      collections: [],
      groups: [],
      users: [],
      isEdit: false,
      isNew: false,
      Search: "",
      selectedObj: {},
      isLoan: true,
      notify: {
        type: 0,
        message: "",
        errors: [],
      },
      menu1: false,
      menu2: false,
      groupRules: [(v) => v || "Group is required"],
      collectionRules: [(v) => v || "Collection is required"],
      loading: false,
      paging: { count: 10, page: 1, size: 10, keyword: "" },
      overlay: false
    };
  },
};
</script>

<style scoped>
.icon-edit {
  color: #1975d2;
}
.icon-delete {
  color: red;
}
.col {
  padding: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/Organization/OrgCollectionGroup.vue